import React, { useState } from 'react';
import Icon from 'components/AppIcon';
import Button from 'components/ui/Button';
import Input from 'components/ui/Input';

const LocationSettingsTab = ({selectedBusiness }) => {
  const [formData, setFormData] = useState({
    address: {
      street: '123 Main Street',
      city: 'Los Angeles',
      state: 'CA',
      zipCode: '90210',
      country: 'United States'
    },
    coordinates: {
      latitude: '34.0522',
      longitude: '-118.2437'
    },
    serviceArea: {
      radius: '15',
      unit: 'miles'
    },
    parkingInfo: {
      hasParking: true,
      parkingSpaces: '20',
      parkingType: 'Free'
    },
    accessibility: {
      wheelchairAccessible: true,
      hasRestrooms: true,
      hasWaitingArea: true
    }
  });

  const [hasChanges, setHasChanges] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});

  const handleInputChange = (field, value) => {
    const fieldParts = field?.split('.');
    if (fieldParts?.length === 2) {
      const [parent, child] = fieldParts;
      setFormData(prev => ({
        ...prev,
        [parent]: {
          ...prev?.[parent],
          [child]: value
        }
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [field]: value
      }));
    }
    setHasChanges(true);
    
    // Clear validation error for this field
    if (validationErrors?.[field]) {
      setValidationErrors(prev => ({
        ...prev,
        [field]: ''
      }));
    }
  };

  const validateForm = () => {
    const errors = {};
    
    // Zip code validation
    const zipRegex = /^\d{5}(-\d{4})?$/;
    if (formData?.address?.zipCode && !zipRegex?.test(formData?.address?.zipCode)) {
      errors['address.zipCode'] = 'Please enter a valid ZIP code';
    }
    
    // Coordinates validation
    const lat = parseFloat(formData?.coordinates?.latitude);
    const lng = parseFloat(formData?.coordinates?.longitude);
    
    if (isNaN(lat) || lat < -90 || lat > 90) {
      errors['coordinates.latitude'] = 'Latitude must be between -90 and 90';
    }
    
    if (isNaN(lng) || lng < -180 || lng > 180) {
      errors['coordinates.longitude'] = 'Longitude must be between -180 and 180';
    }
    
    setValidationErrors(errors);
    return Object.keys(errors)?.length === 0;
  };

  const handleSave = () => {
    if (validateForm()) {
      
    }
  };

  const handleGetCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation?.getCurrentPosition(
        (position) => {
          handleInputChange('coordinates.latitude', position?.coords?.latitude?.toString());
          handleInputChange('coordinates.longitude', position?.coords?.longitude?.toString());
        },
        (error) => {
          console.error('Error getting location:', error);
        }
      );
    }
  };

  const stateOptions = [
    'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA',
    'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD',
    'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ',
    'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC',
    'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY'
  ];

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h3 className="text-lg font-semibold text-foreground">Location Settings</h3>
          <p className="text-sm text-muted-foreground">
            Configure your business address, service area, and location details
          </p>
        </div>
        {hasChanges && (
          <div className="flex items-center space-x-2">
            <div className="status-indicator warning"></div>
            <span className="text-sm text-warning">Unsaved changes</span>
          </div>
        )}
      </div>
      {/* Business Address */}
      <div className="bg-card border border-border rounded-lg p-6">
        {/* <h4 className="text-md font-medium text-foreground mb-4">Business Address</h4>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="lg:col-span-2">
            <Input
              label="Street Address"
              type="text"
              placeholder="123 Main Street"
              value={formData?.address?.street}
              onChange={(e) => handleInputChange('address.street', e?.target?.value)}
              required
            />
          </div>

          <Input
            label="City"
            type="text"
            placeholder="Los Angeles"
            value={formData?.address?.city}
            onChange={(e) => handleInputChange('address.city', e?.target?.value)}
            required
          />

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-foreground mb-2">
                State
              </label>
              <select
                className="w-full px-3 py-2 border border-border rounded-lg bg-input text-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent"
                value={formData?.address?.state}
                onChange={(e) => handleInputChange('address.state', e?.target?.value)}
              >
                {stateOptions?.map(state => (
                  <option key={state} value={state}>{state}</option>
                ))}
              </select>
            </div>

            <Input
              label="ZIP Code"
              type="text"
              placeholder="90210"
              value={formData?.address?.zipCode}
              onChange={(e) => handleInputChange('address.zipCode', e?.target?.value)}
              error={validationErrors?.['address.zipCode']}
              required
            />
          </div>

          <Input
            label="Country"
            type="text"
            placeholder="United States"
            value={formData?.address?.country}
            onChange={(e) => handleInputChange('address.country', e?.target?.value)}
            required
          />
        </div> */}
         <div className="flex items-center justify-center">
          <h3 className=''>Coming soon...</h3>
        </div>
      </div>
      {/* Map & Coordinates */}
      {/* <div className="bg-card border border-border rounded-lg p-6">
        <h4 className="text-md font-medium text-foreground mb-4">Map Location</h4>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <Input
                label="Latitude"
                type="number"
                step="any"
                placeholder="34.0522"
                value={formData?.coordinates?.latitude}
                onChange={(e) => handleInputChange('coordinates.latitude', e?.target?.value)}
                error={validationErrors?.['coordinates.latitude']}
              />

              <Input
                label="Longitude"
                type="number"
                step="any"
                placeholder="-118.2437"
                value={formData?.coordinates?.longitude}
                onChange={(e) => handleInputChange('coordinates.longitude', e?.target?.value)}
                error={validationErrors?.['coordinates.longitude']}
              />
            </div>

            <Button
              variant="outline"
              size="sm"
              onClick={handleGetCurrentLocation}
              iconName="MapPin"
              iconPosition="left"
              iconSize={16}
            >
              Use Current Location
            </Button>
          </div>

          <div className="h-64 bg-muted rounded-lg overflow-hidden">
            <iframe
              width="100%"
              height="100%"
              loading="lazy"
              title="Business Location"
              referrerPolicy="no-referrer-when-downgrade"
              src={`https://www.google.com/maps?q=${formData?.coordinates?.latitude},${formData?.coordinates?.longitude}&z=14&output=embed`}
            />
          </div>
        </div>
      </div> */}
      {/* Service Area */}
      {/* <div className="bg-card border border-border rounded-lg p-6">
        <h4 className="text-md font-medium text-foreground mb-4">Service Area</h4>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2">
            <Input
              label="Service Radius"
              type="number"
              placeholder="15"
              value={formData?.serviceArea?.radius}
              onChange={(e) => handleInputChange('serviceArea.radius', e?.target?.value)}
              description="How far from your location do you provide services?"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Unit
            </label>
            <select
              className="w-full px-3 py-2 border border-border rounded-lg bg-input text-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent"
              value={formData?.serviceArea?.unit}
              onChange={(e) => handleInputChange('serviceArea.unit', e?.target?.value)}
            >
              <option value="miles">Miles</option>
              <option value="kilometers">Kilometers</option>
            </select>
          </div>
        </div>

        <div className="mt-4 p-4 bg-muted/30 rounded-lg">
          <div className="flex items-center space-x-2 mb-2">
            <Icon name="Info" size={16} className="text-primary" />
            <span className="text-sm font-medium text-foreground">Service Coverage</span>
          </div>
          <p className="text-sm text-muted-foreground">
            Your services are available within {formData?.serviceArea?.radius} {formData?.serviceArea?.unit} of your business location. 
            This includes mobile car wash and pickup/delivery services.
          </p>
        </div>
      </div> */}
      {/* Facility Information */}
      {/* <div className="bg-card border border-border rounded-lg p-6">
        <h4 className="text-md font-medium text-foreground mb-4">Facility Information</h4>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="space-y-4">
            <h5 className="text-sm font-medium text-foreground">Parking Information</h5>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <input
                  type="checkbox"
                  id="hasParking"
                  checked={formData?.parkingInfo?.hasParking}
                  onChange={(e) => handleInputChange('parkingInfo.hasParking', e?.target?.checked)}
                  className="w-4 h-4 text-primary bg-input border-border rounded focus:ring-ring focus:ring-2"
                />
                <label htmlFor="hasParking" className="text-sm text-foreground">
                  Parking available
                </label>
              </div>

              {formData?.parkingInfo?.hasParking && (
                <>
                  <Input
                    label="Number of Parking Spaces"
                    type="number"
                    placeholder="20"
                    value={formData?.parkingInfo?.parkingSpaces}
                    onChange={(e) => handleInputChange('parkingInfo.parkingSpaces', e?.target?.value)}
                  />

                  <div>
                    <label className="block text-sm font-medium text-foreground mb-2">
                      Parking Type
                    </label>
                    <select
                      className="w-full px-3 py-2 border border-border rounded-lg bg-input text-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent"
                      value={formData?.parkingInfo?.parkingType}
                      onChange={(e) => handleInputChange('parkingInfo.parkingType', e?.target?.value)}
                    >
                      <option value="Free">Free</option>
                      <option value="Paid">Paid</option>
                      <option value="Validated">Validated</option>
                    </select>
                  </div>
                </>
              )}
            </div>
          </div>

          <div className="space-y-4">
            <h5 className="text-sm font-medium text-foreground">Accessibility Features</h5>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <input
                  type="checkbox"
                  id="wheelchairAccessible"
                  checked={formData?.accessibility?.wheelchairAccessible}
                  onChange={(e) => handleInputChange('accessibility.wheelchairAccessible', e?.target?.checked)}
                  className="w-4 h-4 text-primary bg-input border-border rounded focus:ring-ring focus:ring-2"
                />
                <label htmlFor="wheelchairAccessible" className="text-sm text-foreground">
                  Wheelchair accessible
                </label>
              </div>

              <div className="flex items-center space-x-3">
                <input
                  type="checkbox"
                  id="hasRestrooms"
                  checked={formData?.accessibility?.hasRestrooms}
                  onChange={(e) => handleInputChange('accessibility.hasRestrooms', e?.target?.checked)}
                  className="w-4 h-4 text-primary bg-input border-border rounded focus:ring-ring focus:ring-2"
                />
                <label htmlFor="hasRestrooms" className="text-sm text-foreground">
                  Restrooms available
                </label>
              </div>

              <div className="flex items-center space-x-3">
                <input
                  type="checkbox"
                  id="hasWaitingArea"
                  checked={formData?.accessibility?.hasWaitingArea}
                  onChange={(e) => handleInputChange('accessibility.hasWaitingArea', e?.target?.checked)}
                  className="w-4 h-4 text-primary bg-input border-border rounded focus:ring-ring focus:ring-2"
                />
                <label htmlFor="hasWaitingArea" className="text-sm text-foreground">
                  Customer waiting area
                </label>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      {/* Action Buttons */}
      {/* <div className="flex items-center justify-end pt-4 border-t border-border">
        <div className="flex items-center space-x-2">
          <div className="status-indicator active"></div>
          <span className="text-sm text-muted-foreground">Auto-save enabled</span>
        </div>

        <Button
          variant="default"
          onClick={handleSave}
          disabled={!hasChanges}
          loading={isLoading}
          iconName="Save"
          iconPosition="left"
          iconSize={16}
        >
          Save Changes
        </Button>
      </div> */}
    </div>
  );
};

export default LocationSettingsTab;